module.exports = __webpack_public_path__ + "img/Undo.d2ad1c04.svg";